export default function BlikPhoneDecoration() {
  return (
    <svg
      width="420"
      height="420"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <style>{`
        @keyframes blik-phone-shake {
          0%   { transform: rotate(0deg); }
          8%   { transform: rotate(14deg); }
          16%  { transform: rotate(-14deg); }
          24%  { transform: rotate(14deg); }
          32%  { transform: rotate(-14deg); }
          40%  { transform: rotate(0deg); }
          100% { transform: rotate(0deg); }
        }
        .blik-phone-shake {
          transform-box: fill-box;
          transform-origin: center;
          animation: blik-phone-shake 1.8s ease-in-out infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .blik-phone-shake { animation: none; }
        }
      `}</style>
      <defs>
        <filter id="blikPhoneShadow" x="-40%" y="-40%" width="180%" height="180%">
          <feDropShadow dx="0" dy="5" stdDeviation="4" floodColor="#1F2937" floodOpacity="0.28" />
        </filter>
      </defs>
      <g filter="url(#blikPhoneShadow)">
        <g className="blik-phone-shake">
          <rect x="52" y="18" width="56" height="124" rx="14" fill="#EEF2FF" stroke="#1F2937" strokeWidth="0.2" />
          <line x1="52" y1="34" x2="108" y2="34" stroke="#1F2937" strokeWidth="0.2" />
          <line x1="52" y1="126" x2="108" y2="126" stroke="#1F2937" strokeWidth="0.2" />
          <line x1="72" y1="26" x2="88" y2="26" stroke="#1F2937" strokeWidth="1" strokeLinecap="round" />
          <line x1="64" y1="52" x2="96" y2="52" stroke="#94A3B8" strokeWidth="1" strokeLinecap="round" />
          <line x1="64" y1="64" x2="86" y2="64" stroke="#94A3B8" strokeWidth="1" strokeLinecap="round" />
          <rect x="62" y="92" width="36" height="10" rx="5" fill="#F97316" />
          <rect x="65.5" y="132" width="4" height="4" rx="1" fill="#1F2937" />
          <circle cx="80" cy="134" r="2.5" fill="#1F2937" />
          <polygon points="94,131.5 90.5,134 94,136.5" fill="#1F2937" />
        </g>
      </g>
    </svg>
  );
}
